import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';
import { CaseStateType } from 'types';

export const selectCase = createSelector(
  (state: GlobalState) => state.case,
  (caseObject: CaseStateType) => caseObject.case,
);

export const selectCaseError = createSelector(
  (state: GlobalState) => state.case,
  (caseObject: CaseStateType) => caseObject.error,
);

export const selectIsCaseLoading = createSelector(
  (state: GlobalState) => state.case,
  (caseObject: CaseStateType) => caseObject.isLoading,
);

export const selectSelectedCaseDocuments = createSelector(
  (state: GlobalState) => state.case,
  (caseObject: CaseStateType) => caseObject.selectedToDistribute,
);
